import register from 'preact-custom-element'
import { useState } from 'preact/hooks'
import ProductCard from 'snippets/product-card/product-card'
import { getProductTitle } from 'libs/shopify'
import './product-related.css'

function ProductRelated({ title, soldOutLabel, singleProductsTitle, bundleAndSaveTitle, includesLabel, saveLabel }) {
  const hasRelatedProducts = relatedProducts && relatedProducts.length > 0
  const hasBundleProducts = bundleAndSaveProducts && bundleAndSaveProducts.length > 0
  const showTabs = hasRelatedProducts && hasBundleProducts

  const getInitialActiveTab = () => {
    if (hasBundleProducts) return 1
    if (hasRelatedProducts) return 0
    return 0
  }

  const [activeTab, setActiveTab] = useState(getInitialActiveTab)

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex)
  }

  return (
    <div className="pt-6 pb-4 md-max:relative md-max:before:absolute md-max:before:border-t md-max:before:top-0 md-max:before:-left-4 md-max:before:w-[calc(100%_+_32px)] lg:pb-8">
      <div className="mb-4 text-xl text-center text-grey-1000">{title}</div>
      <div className="tabs-container">
        {showTabs && (
          <div className="tabs my-7" data-tabs style={{ '--background-offset': `${activeTab * 100}%` }}>
            <button
              className={`tabs__button ${activeTab === 0 ? 'active' : ''}`}
              aria-selected={activeTab === 0}
              onClick={() => handleTabClick(0)}
            >
              {singleProductsTitle}
            </button>
            <button
              className={`tabs__button ${activeTab === 1 ? 'active' : ''}`}
              aria-selected={activeTab === 1}
              onClick={() => handleTabClick(1)}
            >
              {bundleAndSaveTitle}
            </button>
          </div>
        )}

        {hasRelatedProducts && (
          <div className="relative w-full tabs__single-products" style={{ display: showTabs ? (activeTab === 0 ? 'block' : 'none') : 'block' }}>
            {relatedProducts.map((product) => (
              <ProductCard
                title={getProductTitle(product.title)}
                handle={product.handle}
                imageUrl={[product.featuredImage]}
                variants={product.variants}
                size={product.metafields.sizes}
                className="relative flex items-start pr-6 mb-4 bg-white rounded last:mb-0"
                classImageWrapper="relative w-[80px] min-w-[80px]"
                isCover
                soldOutLabel={soldOutLabel}
                includesLabel={includesLabel}
                saveLabel={saveLabel}
              />
            ))}
          </div>
        )}

        {hasBundleProducts && (
          <div
            className="relative w-full tabs__bundle-products"
            style={{
              display: showTabs ? (activeTab === 1 ? 'block' : 'none') : 'block',
              maxHeight: '380px'
            }}
          >
            {bundleAndSaveProducts
              .filter((product) => product.available !== false)
              .map((product) => (
                <ProductCard
                  title={getProductTitle(product.title)}
                  handle={product.handle}
                  imageUrl={[product.featuredImage]}
                  variants={product.variants}
                  size={product.metafields.sizes}
                  className="relative flex items-start pr-6 mb-4 bg-white rounded tabs__bundle-product-card last:mb-0"
                  classImageWrapper="relative w-[80px] min-w-[80px]"
                  isCover
                  soldOutLabel={soldOutLabel}
                  bundleChildSkus={product.metafields.bundle_child_skus}
                  showDiscountBadge={true}
                  includesLabel={includesLabel}
                  saveLabel={saveLabel}
                />
              ))}
          </div>
        )}
      </div>
    </div>
  )
}

register(ProductRelated, 'product-related', ['title', 'soldOutLabel', 'singleProductsTitle', 'bundleAndSaveTitle', 'includesLabel', 'saveLabel'])
